export default __webpack_public_path__ + "static/logo-8ee9354c393044a634fa358c375da874.png";